import ChannelSearchFormComponent from './ChannelSearchFormComponent';

export default ChannelSearchFormComponent;
